export default {
  isDebug: false /// updated
};
